export function setToken(value: string) {
  if (typeof window === 'undefined' || !window.localStorage) return;
  window.localStorage.setItem('accessToken', value);
}

export function getToken(): string | null {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  return window.localStorage.getItem('accessToken');
}

export function deleteToken() {
  if (typeof window === 'undefined' || !window.localStorage) return;
  window.localStorage.removeItem('accessToken');
}

export function clearAllUserData() {
  if (typeof window === 'undefined' || !window.localStorage) return;

  // Clear authentication token
  window.localStorage.removeItem('accessToken');
}
